import { Room } from '../room'

const HOTEL_1_LAYOUT: Room[] = [
    // L shape - Vertical part (top to bottom)
    {
        id: '10',
        number: 'HAB.10',
        style: { left: '0%', top: '2%', width: '18%', height: '18%', position: 'absolute' },
    },
    {
        id: '9',
        number: 'HAB.9',
        style: { left: '0%', top: '21%', width: '18%', height: '18%', position: 'absolute' },
    },
    {
        id: '8',
        number: 'HAB.8',
        style: { left: '0%', top: '40%', width: '18%', height: '18%', position: 'absolute' },
    },
    {
        id: '7',
        number: 'HAB.7',
        style: { left: '0%', top: '59%', width: '18%', height: '18%', position: 'absolute' },
    },
    {
        id: '6',
        number: 'HAB.6',
        style: { left: '0%', top: '78%', width: '15%', height: '18%', position: 'absolute' },
    },
    // L shape - Horizontal part (left to right)
    {
        id: '5',
        number: 'HAB.5',
        style: { left: '17%', top: '78%', width: '15%', height: '18%', position: 'absolute' },
    },
    {
        id: '4',
        number: 'HAB.4',
        style: { left: '34%', top: '78%', width: '15%', height: '18%', position: 'absolute' },
    },
    {
        id: '3',
        number: 'HAB.3',
        style: { left: '51%', top: '78%', width: '15%', height: '18%', position: 'absolute' },
    },
    {
        id: '2',
        number: 'HAB.2',
        style: { left: '68%', top: '78%', width: '15%', height: '18%', position: 'absolute' },
    },
    {
        id: '1',
        number: 'HAB.1',
        style: { left: '85%', top: '78%', width: '15%', height: '18%', position: 'absolute' },
    },
    // Center area - Top row (left to right)
    {
        id: '24',
        number: 'HAB.24',
        style: { left: '22%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '23',
        number: 'HAB.23',
        style: { left: '32%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '22',
        number: 'HAB.22',
        style: { left: '42%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '21',
        number: 'HAB.21',
        style: { left: '52%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '20',
        number: 'HAB.20',
        style: { left: '62%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '19',
        number: 'HAB.19',
        style: { left: '72%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '18',
        number: 'HAB.18',
        style: { left: '82%', top: '2%', width: '9%', height: '25%', position: 'absolute' },
    },
    // Center area - Bottom row (left to right)
    {
        id: '17',
        number: 'HAB.17',
        style: { left: '22%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '16',
        number: 'HAB.16',
        style: { left: '32%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '15',
        number: 'HAB.15',
        style: { left: '42%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '14',
        number: 'HAB.14',
        style: { left: '52%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '13',
        number: 'HAB.13',
        style: { left: '62%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '12',
        number: 'HAB.12',
        style: { left: '72%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
    {
        id: '11',
        number: 'HAB.11',
        style: { left: '82%', top: '29%', width: '9%', height: '25%', position: 'absolute' },
    },
]

const HOTEL_2_LAYOUT: Room[] = [
    // Left column (top to bottom)
    {
        id: '30',
        number: 'HAB.30',
        style: { left: '2%', top: '2%', width: '32%', height: '32%', position: 'absolute' },
    },
    {
        id: '29',
        number: 'HAB.29',
        style: { left: '2%', top: '36%', width: '32%', height: '16%', position: 'absolute' },
    },
    {
        id: '28',
        number: 'HAB.28',
        style: { left: '2%', top: '54%', width: '32%', height: '16%', position: 'absolute' },
    },
    {
        id: '27',
        number: 'HAB.27',
        style: { left: '2%', top: '72%', width: '32%', height: '16%', position: 'absolute' },
    },
    {
        id: '26',
        number: 'HAB.26',
        style: { left: '2%', top: '90%', width: '32%', height: '16%', position: 'absolute' },
    },
    {
        id: '25',
        number: 'HAB.25',
        style: { left: '2%', top: '108%', width: '32%', height: '16%', position: 'absolute' },
    },
    // Center area
    {
        id: '31',
        number: 'HAB.31',
        style: { left: '36%', top: '2%', width: '30%', height: '16%', position: 'absolute' },
    },
    // Right column (top to bottom)
    {
        id: '32',
        number: 'HAB.32',
        style: { right: '2%', top: '2%', width: '30%', height: '32%', position: 'absolute' },
    },
    {
        id: '33',
        number: 'HAB.33',
        style: { right: '2%', top: '36%', width: '30%', height: '32%', position: 'absolute' },
    },
    {
        id: '34',
        number: 'HAB.34',
        style: { right: '2%', top: '70%', width: '30%', height: '28%', position: 'absolute' },
    },
]

export { HOTEL_1_LAYOUT as hotel1Layout, HOTEL_2_LAYOUT as hotel2Layout }
